import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function KidsKarateHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-2047">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2048">
        Kids Karate
      </div>
      <div className="mb-8" data-id="element-2049">
        <SocialProofBar data-id="element-2050" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2051">
        Looking for Kids Karate Classes Near Farmington Hills?
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2052">
        Many parents search for “kids karate” when they really mean kids martial
        arts. Storm Taekwondo teaches Olympic-style Taekwondo for confidence,
        discipline, focus and fitness — beginner-friendly for ages 3 and up.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-2053">
        {['Respect for parents, teachers, and peers', 'Goal setting through the belt progression system', 'Physical fitness, balance, and coordination', 'Self-defense fundamentals and stranger awareness'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-2054">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-2055" />
            <span data-id="element-2056">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-2057">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-2058">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-2059">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-2060" />
    </div>;
}